import axios from 'axios'

const nativeGateway = axios.create({
  baseURL: process.env.VUE_APP_NATIVE_GATEWAY_URL || '/native-gateway-wss',
  timeout: 15000
})

function unwrapGatewayResponse(response) {
  const result = response.data

  if (result?.code !== 2000) {
    throw new Error(result?.msg || '媒体网关请求失败')
  }

  return result.data
}

export async function openNativeSession(sessionTicket) {
  const response = await nativeGateway.post('/native/open', { sessionTicket })
  return unwrapGatewayResponse(response)
}

export async function closeNativeSession(routeId) {
  const response = await nativeGateway.post('/native/close', { routeId })
  return unwrapGatewayResponse(response)
}
